import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { DashboardProvider } from './contexts/DashboardContext.jsx';
import Layout from './components/Layout.jsx';
import LoginPage from './pages/LoginPage.jsx';
import DashboardPage from './pages/DashboardPage.jsx';
import OutboundSummaryPage from './pages/OutboundSummaryPage.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={
          <ProtectedRoute>
            <DashboardProvider>
              <Layout>
                <DashboardPage />
              </Layout>
            </DashboardProvider>
          </ProtectedRoute>
        } />
        <Route path="/outbound-summary" element={
          <ProtectedRoute>
            <Layout>
              <OutboundSummaryPage />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;

